import { createDiscreteApi } from 'naive-ui';

const { message, dialog, loadingBar } = createDiscreteApi([
  'message',
  'dialog',
  'loadingBar',
]);
export { message, dialog, loadingBar };
